// extracted by mini-css-extract-plugin
export default {"container":"Ventajas_container__-CIUq","textLeft":"Ventajas_textLeft__qI8DH","title":"Ventajas_title__gydJJ","subTitle":"Ventajas_subTitle__dWb9B","box":"Ventajas_box__BM8ei"};